import { Component, DestroyRef, inject, signal, Type, viewChild } from '@angular/core';
import { LocalizationService } from '@abp/ng.core';
import { Router } from '@angular/router';
import {
  IWizardStepDefinition,
  ModalBuilder,
  buildLocalizedStepDefinitions,
  hasWizardPendingChanges,
  redirectToHome,
  StepperSuccessModal,
  showCancelConfirmationOrRedirect,
  ZnConfirmation,
  ZnStepperWizard,
} from '@zendra/shared';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  COMPLETE_STEPPER_MESSAGE,
  CONTRACTASSIGNMENTBYSTAND_CONFIG,
  STEP_COMPONENTS_CONFIG,
} from './contract-assignment-by-stand.config';
import { IContractSelectStepData } from './interfaces/IContractSelectStepData';
import { IAssociateStandCycleRotationStepData } from './interfaces/IAssociateStandCycleRotation';
import { ISetPropertyTypeStepData } from './interfaces/ISetPropertyTypeStepData';
import { ContractAssociationOrchestratorService } from 'orchestrator/proxy';

@Component({
  selector: 'lib-contract-assignment-by-stand',
  standalone: true,
  imports: [ZnStepperWizard, StepperSuccessModal],
  templateUrl: './contract-assignment-by-stand.html',
})
export class ContractAssignmentByStand {
  private readonly confirmationService = inject(ZnConfirmation);
  private readonly localizationService = inject(LocalizationService);
  private readonly modalBuilder = inject(ModalBuilder);
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);
  private readonly contractAssociationService = inject(ContractAssociationOrchestratorService);

  protected readonly wizard = viewChild(ZnStepperWizard);
  protected readonly successModalVisible = signal(false);
  protected readonly successMessageKey =
    'Geographic::ContractAssignmentByStand.StepSetPropertyType.SuccessMessage';
  private readonly localizationKeyPrefix =
    CONTRACTASSIGNMENTBYSTAND_CONFIG.localizationKey;

  protected readonly stepDefinitions: IWizardStepDefinition[] = buildLocalizedStepDefinitions(
    this.localizationService,
    this.localizationKeyPrefix,
    STEP_COMPONENTS_CONFIG,
  );

  protected onSubmitWizard(_data: Record<number, unknown>) {
    const step1 = _data[1] as IContractSelectStepData;
    const step3 = _data[3] as IAssociateStandCycleRotationStepData;
    const step4 = _data[4] as ISetPropertyTypeStepData;

    console.log('--- SCR Ids ---')
    console.log(step3)
    
    const modalRef = this.modalBuilder.openModal(
      COMPLETE_STEPPER_MESSAGE.component as Type<any>,
      COMPLETE_STEPPER_MESSAGE,
    );

    modalRef.closed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((confirm: boolean) => {
      if (confirm) {
        this.contractAssociationService.finalizeContractAssociation({
          standCycleRotationIds: step3.rowsIds.map(Number),
          landContractId: step1.landContractToAssociate?.key
            ? Number(step1.landContractToAssociate.key)
            : null,
          fomentContractId: step1.forestContractToAssociate?.key
            ? Number(step1.forestContractToAssociate.key)
            : null,
          propertyTypeId: step4.propertyTypeId ? Number(step4.propertyTypeId) : undefined,
        })
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: () => {
            this.successModalVisible.set(true);
          },
          error: error => {
            console.log(error);
          },
        });
      }
    });
  }

  protected onCancel() {
    showCancelConfirmationOrRedirect(
      this.confirmationService,
      this.hasPendingChanges(),
      () => void redirectToHome(this.router),
    );
  }

  protected hasPendingChanges(): boolean {
    return hasWizardPendingChanges(this.wizard());
  }

  protected async onSuccessModalVisibleChange(isVisible: boolean): Promise<void> {
    this.successModalVisible.set(isVisible);
    if (!isVisible) {
      await redirectToHome(this.router);
    }
  }
}
